/* eslint no-template-curly-in-string: 0 */
import { FLOW_TYPES, PAYMENT_STATUSES } from "../../../../utils/enums";

export const target = {
  id: "EGIFT_BLACKHAWK_TARGET",
  displayName: "Target",
  paymentFlow: "email",
  paywall: {
    tile: {
      displayName: "Target eGiftCard™",
      tagline: "Use en línea o en la tienda",
      description: [
        {
          string: "Fondos inmediatos para comprar sus artículos",
          type: "div",
        },
        {
          string: "favoritos, regalos y más",
          type: "div",
        },
      ],
    }
  },
  recipientLogin: {
    flow: FLOW_TYPES.RECIPIENT_LOGIN.AUTO_LOGIN,
    loading: {
      title: "Preparando su Target eGiftCard™"
    }
  },
  acceptPayment: {
    flow: FLOW_TYPES.ACCEPT_PAYMENT.AUTO_ACCEPT,
    description: [
      "Ha elegido recibir una Target eGiftCard de ",
      {
        string: "${payment.amount}",
        transformations: [
          {
            type: "formatAsCurrency",
            data: {
              currency: "${payment.currency}"
            }
          }
        ],
        props: {
          className: "payment-amount",
        }
      },
      " que será enviado por correo electrónico a ",
      {
        string: "${payment.recipientEmail}",
        props: {
          className: 'payment-recipientEmail'
        }
      },
      "."
    ],
  },
  paymentComplete: {
    initial: {
      description: [
        "¡Éxito! Por favor, revise su correo electrónico ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail'
          },
        },
        " para obtener más información con respecto a su ",
        {
          string: "Target eGiftCard™",
          props: {
            className: 'payment-paymentNetwork'
          }
        },
        " de ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        ". Debería llegarle pronto e incluirá los detalles para su uso. ",
      ],
      secondaryText: "Por favor, considere esta tarjeta como si fuese dinero en efectivo y tenga el debido cuidado para evitar la pérdida o robo.",
    },
    revisit: {
      description: [
        "El ",
        {
          string: "${payment.updatedAt}",
          props: {
            className: 'payment-updatedAt',
          },
          transformations: [
            {
              type: "formatDate"
            }
          ],
        },
        ", un correo electrónico fue enviado a ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail'
          },
        },
        " con los detalles respecto a su ",
        {
          string: "Target eGiftCard™",
          props: {
            className: 'payment-paymentNetwork'
          }
        },
        " de ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        "."
        ],
      secondaryText: "Por favor, considere esta tarjeta como si fuese dinero en efectivo y tenga el debido cuidado para evitar la pérdida o robo.",
    },
  },
  faqs: {
    byPaymentStatus: {
      [PAYMENT_STATUSES.PENDING_ACCEPTANCE]: [
        {
          answer: "Las tarjetas de regalo de Target le permiten comprar miles de artículos en más de 1700 tiendas de Target en los EE. UU. y en línea en Target.com. Desde juguetes hasta productos electrónicos, ropa y artículos para el hogar, encuentre exactamente lo que está buscando en Target. Son la opción gratificante.<br/><br/>Se puede canjear por mercancías o servicios (que no sean tarjetas de regalo y tarjetas de prepago) en las tiendas Target de los Estados Unidos o en Target.com, y no se puede canjear por dinero en efectivo o crédito, excepto cuando lo exija la ley. No tiene valor hasta que se compra. Para obtener información sobre el saldo, visite Target.com/giftcards o llame al <a href=\"tel:+1-800-544-2943\">1-800-544-2943</a>. Para reemplazar el valor restante de una tarjeta perdida, robada o dañada con el recibo de compra original, llame al <a href=\"tel:+1-800-544-2943\">1-800-544-2943</a>. ©2018 Target Brands,Inc. El diseño de Bullseye y Target son marcas registradas de Target Brands, Inc. El Bullseye Design, Target y Target GiftCards son marcas registradas de Target Brands, Inc.  Los términos y condiciones se aplican a las tarjetas de regalo. Target no es un socio participante o patrocinador de esta oferta.",
          question: "Acerca de la tarjeta electrónica de regalo de Target®"
        }
      ],
      [PAYMENT_STATUSES.COMPLETE]: [
        {
          answer: "Las tarjetas de regalo de Target le permiten comprar miles de artículos en más de 1700 tiendas de Target en los EE. UU. y en línea en Target.com. Desde juguetes hasta productos electrónicos, ropa y artículos para el hogar, encuentre exactamente lo que está buscando en Target. Son la opción gratificante.<br/><br/>Se puede canjear por mercancías o servicios (que no sean tarjetas de regalo y tarjetas de prepago) en las tiendas Target de los Estados Unidos o en Target.com, y no se puede canjear por dinero en efectivo o crédito, excepto cuando lo exija la ley. No tiene valor hasta que se compra. Para obtener información sobre el saldo, visite Target.com/giftcards o llame al <a href=\"tel:+1-800-544-2943\">1-800-544-2943</a>. Para reemplazar el valor restante de una tarjeta perdida, robada o dañada con el recibo de compra original, llame al <a href=\"tel:+1-800-544-2943\">1-800-544-2943</a>. ©2018 Target Brands,Inc. El diseño de Bullseye y Target son marcas registradas de Target Brands, Inc. El Bullseye Design, Target y Target GiftCards son marcas registradas de Target Brands, Inc.  Los términos y condiciones se aplican a las tarjetas de regalo. Target no es un socio participante o patrocinador de esta oferta.",
          question: "Acerca de la tarjeta electrónica de regalo de Target®"
        }
      ]
    }
  },
};

export default target;
